module.exports = __webpack_public_path__ + "assets/img/360-degrees.93ebcca4.svg";